var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "name" },
      [
        _c("vs-input", {
          attrs: { placeholder: _vm.$t("dash.pages.group_placeholder") },
          model: {
            value: _vm.form.name,
            callback: function ($$v) {
              _vm.$set(_vm.form, "name", $$v)
            },
            expression: "form.name",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "pages-available" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("dash.pages.group.available_pages")) +
            "\n      "
        ),
        _c(
          "span",
          {
            on: {
              click: function ($event) {
                _vm.showAllPages = !_vm.showAllPages
              },
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  !_vm.showAllPages
                    ? _vm.$t("dash.pages.group.all_pages")
                    : _vm.$t("dash.pages.groups.without")
                ) +
                "\n      "
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "search-page" },
          [
            _c("vs-input", {
              staticClass: "inputx",
              class: { input: true },
              attrs: {
                color: "#B20564",
                "icon-after": "true",
                icon: "search",
                placeholder: _vm.$t("dash.settings.user.label.page_filter"),
              },
              model: {
                value: _vm.pageFilter,
                callback: function ($$v) {
                  _vm.pageFilter = $$v
                },
                expression: "pageFilter",
              },
            }),
          ],
          1
        ),
        _c(
          "ul",
          _vm._l(_vm.pages, function (item) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "page",
                class: [
                  {
                    hide:
                      !_vm.checkPageFilter(item) ||
                      _vm.checkPagesInGroups(item),
                    select: _vm.selectedToAdd.find((p) => p.id == item.id),
                  },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectAvailable(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c(
                        "Tooltip",
                        { attrs: { text: item.name, position: "top" } },
                        [
                          _c("page-image-avatar", { attrs: { page: item } }),
                          _c("p", { staticClass: "page-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm._v("\n                 \n              "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "actions" }, [
      _c("div", { staticClass: "all", on: { click: _vm.all } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-RAZ.svg"),
            alt: "icon RAZ",
          },
        }),
      ]),
      _c("div", { staticClass: "add", on: { click: _vm.add } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-right-arrow.svg"),
            alt: "icon right arrow",
          },
        }),
      ]),
      _c("div", { staticClass: "remove", on: { click: _vm.remove } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-left-arrow.svg"),
            alt: "icon left arrow",
          },
        }),
      ]),
      _c("div", { staticClass: "raz", on: { click: _vm.raz } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-RAZ.svg"),
            alt: "icon RAZ",
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "pages-affected" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("dash.pages.group.in_group"))),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "ul",
          _vm._l(_vm.form.pages, function (item, index) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "page",
                class: [
                  { select: _vm.selectedToRemove.find((p) => p.id == item.id) },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectAffected(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c(
                        "Tooltip",
                        { attrs: { text: item.name, position: "top" } },
                        [
                          _c("page-image-avatar", { attrs: { page: item } }),
                          _c("p", { staticClass: "page-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm._v("\n                 \n              "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "position" }, [
                    _c(
                      "div",
                      {
                        staticClass: "top",
                        class: [{ disable: index == 0 }],
                        on: {
                          click: function ($event) {
                            return _vm.changePosition(index, index - 1)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "hide-group",
                          attrs: {
                            alt: "top",
                            src: require("../../../assets/img/icon-hide-group.svg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bottom",
                        class: [
                          { disable: index == _vm.form.pages.length - 1 },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changePosition(index, index + 1)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "hide-group",
                          attrs: {
                            alt: "bottom",
                            src: require("../../../assets/img/icon-hide-group.svg"),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "submit" },
      [
        _vm.group.id
          ? _c(
              "vs-button",
              {
                staticClass: "delete",
                attrs: { color: "#6a1f4c" },
                on: {
                  click: function ($event) {
                    return _vm.erase()
                  },
                },
              },
              [_c("p", [_vm._v(_vm._s(_vm.$t("dash.pages.group.remove")))])]
            )
          : _vm._e(),
        _c(
          "vs-button",
          {
            staticClass: "validate",
            attrs: { color: "#6a1f4c" },
            on: { click: _vm.submit },
          },
          [_c("p", [_vm._v(_vm._s(_vm.$t("dash.pages.overlay.validate")))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }